import { TaskStatus } from '@/renderer/scripts/utils/TaskManager/types';

export const TaskStatusUtil = {
  /**
   * 是否在checking状态前
   * @param status 任务状态
   * @param include true是闭区间,false为开区间
   */
  isBeforeChecking(status: TaskStatus, include = false): boolean {
    return status === TaskStatus.waiting || status === TaskStatus.ready || (include && status === TaskStatus.checking);
  },
  /**
   * 是否在preparing状态前
   * @param status 任务状态
   * @param include true是闭区间,false为开区间
   */
  isBeforePreparing(status: TaskStatus, include = false): boolean {
    return (
      status === TaskStatus.checking || this.isBeforeChecking(status) || (include && status === TaskStatus.preparing)
    );
  },
  /**
   * 是否在running状态前
   * @param status 任务状态
   * @param include true是闭区间,false为开区间
   */
  isBeforeRunning(status: TaskStatus, include = false): boolean {
    return (
      status === TaskStatus.preparing || this.isBeforePreparing(status) || (include && status === TaskStatus.running)
    );
  },
  // 在ready情况任务才可以开始处理进程
  isReady(status: TaskStatus) {
    return status === TaskStatus.ready;
  },
  isChecking(status: TaskStatus) {
    return status === TaskStatus.ready;
  },
  isRunning(status: TaskStatus): boolean {
    return (
      status === TaskStatus.waiting ||
      status === TaskStatus.ready ||
      status === TaskStatus.checking ||
      status === TaskStatus.preparing ||
      status === TaskStatus.running
    );
  },

  isFinished(status: TaskStatus): boolean {
    return (
      status === TaskStatus.success ||
      status === TaskStatus.error ||
      status === TaskStatus.canceled ||
      status === TaskStatus.finish
    );
  },

  isError(status: TaskStatus): boolean {
    return status === TaskStatus.error;
  },
  // 停止中
  isStopped(status: TaskStatus): boolean {
    return !TaskStatusUtil.isRunning(status) && !TaskStatusUtil.isError(status);
  },
};
// 后续文件任务在这里处理
export const TaskFileUtil = {};
export const TaskUtils = {
  TaskStatusUtil,
  TaskFileUtil,
};
